import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function PrintLayout({ children }) {
  const navigate = useNavigate();

  const returnTo = window.history.state?.usr?.returnTo || "/admin-dashboard";

  useEffect(() => {
    const timer = setTimeout(() => {
      window.print();
    }, 500);

    const handleAfterPrint = () => {
      navigate(returnTo);
    };

    window.addEventListener("afterprint", handleAfterPrint);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("afterprint", handleAfterPrint);
    };
  }, [navigate, returnTo]);

  // return <div>{children}</div>;
    return (
      <div style={{ padding: "30px", fontFamily: "Arial" }}>
        
        {/* HEADER */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2>BR Ambedkar Fund</h2>
          <p>Akbarpur Chaidri ,NayaGaon, Dhampur Road Kanth, Moradbad UP 244501</p>
          <hr />
        </div>
  
        {/* CONTENT */}
        {children}
  
        {/* FOOTER */}
        <div style={{ marginTop: "50px", textAlign: "right" }}>
          <p>Authorized Signature</p>
        </div>
      </div>
    );
}
